import React from 'react';
import { Button as MuiButton, type ButtonProps as MuiButtonProps } from '@mui/material';

export interface CancelButtonProps extends Omit<MuiButtonProps, 'variant'> {
    width?: string | number;
}

const CancelButton: React.FC<CancelButtonProps> = ({ children, width = '202px', sx, ...props }) => {
    return (
        <MuiButton
            {...props}
            sx={{
                color: '#FF6D5A',
                border: '1px solid #E3E2E2',
                borderRadius: '16px',
                textTransform: 'none',
                width: width,
                height: '48px',
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 500,
                '&:hover': {
                    border: '1px solid #FF6D5A',
                    backgroundColor: 'transparent',
                },
                ...sx,
            }}
        >
            {children}
        </MuiButton>
    );
};

export default CancelButton;
